const ACTIONS = {
    general: 1,
    appointment: 2,
    enrollment: 4,
    application: 5,
};
export default class CampaignActionDomainService {
    static get AppointmentId() {
        return ACTIONS.appointment;
    }
    static get ApplicationId() {
        return ACTIONS.application;
    }
    static get EnrollmentId() {
        return ACTIONS.enrollment;
    }
    static get GeneralId() {
        return ACTIONS.general;
    }
    static getCampaignTypes() {
        return Object.assign({}, ACTIONS);
    }
}
